import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function ReportingIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame {...props}>
      <rect
        x="7"
        y="9"
        width="34"
        height="35"
        rx="5"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3"
      />
      <rect x="17" y="4" width="14" height="9" rx="3" fill={toolIconPrimary} />
      <path
        d="M15 37V32"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 37V27"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 37V21"
        fill="none"
        stroke={toolIconSecondary}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
